// extracted by mini-css-extract-plugin
export var content = "resource-card-module--content--AqGWg";
export var overlay = "resource-card-module--overlay--LSv2W";
export var resourceCard = "resource-card-module--resourceCard--UtD6+";